// extracted by mini-css-extract-plugin
export default {"order":"FormSection_order__h-T4C","padding":"FormSection_padding__+ExeE"};